export class AccessTokenModel {
  access_token: string;
  expires_in: number;
  refresh_token: string;
  token_type: string;
}
export class RefreshedAccessTokenModel {
  access_token: string;
  expires_in: number;
  token_type: string;
}
